import React from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import "@/index.css";
import App from "@/App";

if (typeof window !== "undefined") {
  window.__INITIAL_PRERENDERED_HACKATHON__ = Boolean(
    document.querySelector('[data-prerender="hero"] #hk-title')
  );
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>,
);
